import { useI18n } from "../contexts/I18nContext";
import { LEGAL_CONTENT, LEGAL_LAST_UPDATED } from "../lib/legalContent";

export default function LegalPage({ pageKey }) {
  const { lang, t } = useI18n();
  const content = LEGAL_CONTENT[pageKey]?.[lang] || LEGAL_CONTENT[pageKey]?.lt;

  if (!content) return null;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid={`legal-${pageKey}`}>
      <h1 className="text-4xl sm:text-5xl font-heading font-black tracking-tight text-[#1A1A18]">
        {content.title}
      </h1>
      <p className="mt-3 text-sm text-[#7A7A73]">
        {t("legal_last_updated")}: <span className="font-mono">{LEGAL_LAST_UPDATED}</span>
      </p>

      <div className="mt-8 space-y-8">
        {content.sections.map((s, idx) => (
          <section key={idx} data-testid={`legal-section-${idx}`}>
            <h2 className="text-lg md:text-lg font-heading font-bold text-[#1A1A18]">
              {s.h}
            </h2>
            <div className="mt-3 space-y-3 text-[#1A1A18] leading-relaxed">
              {s.p.map((para, i) => (
                <p key={i} className="text-base">{para}</p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
